import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { watchErrors } from "./lib/errlog";
import "./styles.css";

// the last errors go with a bug report (components/BugButton.tsx)
watchErrors();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
